<div class="p-grid p-align-stretch vertical-container p-px-3 p-mt-0">
  <!-- Header row: last-updated + refresh on the right -->
  <div class="p-col-12 p-px-0 p-px-md-3">
    <div class="dashboard-shell-header">
      <div class="dashboard-shell-header-left">
        <!-- Filters / dropdowns slot -->
        <ng-content select="[filters]"></ng-content>
        <p *ngIf="description" class="p-mb-1 p-md-sm-0">{{ description }}</p>
      </div>
      <div class="dashboard-shell-header-actions">
        <span *ngIf="lastReload && !loading && showLastUpdated" class="dashboard-shell-last-updated">
          Last updated <app-time-since [unixTime]="lastReload"></app-time-since>
        </span>
        <ng-container *ngIf="showRefresh">
          <!-- Auto-reload toggle — placed to the LEFT of the manual refresh -->
          <button
            *ngIf="showAutoReload"
            type="button"
            class="dashboard-shell-refresh-button dashboard-shell-autoreload-button"
            [class.dashboard-shell-autoreload-button--active]="autoReload"
            (click)="toggleAutoReload()"
            [pTooltip]="autoReload ? 'Auto-reload ON · every ' + autoReloadInterval + 's (click to disable)' : 'Enable auto-reload every ' + autoReloadInterval + 's'"
            tooltipPosition="bottom"
            [attr.aria-pressed]="autoReload"
            aria-label="Toggle auto-reload"
          >
            <i
              class="pi dashboard-shell-refresh-icon"
              [class.pi-clock]="!autoReload"
              [class.pi-spin]="autoReload"
              [class.pi-sync]="autoReload"
              aria-hidden="true"
            ></i>
          </button>

          <!-- Manual refresh -->
          <button
            *ngIf="!loading; else loadingSpinner"
            type="button"
            class="dashboard-shell-refresh-button"
            (click)="refresh.emit()"
            pTooltip="Refresh"
            tooltipPosition="bottom"
            aria-label="Refresh data"
          >
            <i class="pi pi-refresh dashboard-shell-refresh-icon" aria-hidden="true"></i>
          </button>
          <ng-template #loadingSpinner>
            <span class="dashboard-shell-refresh-button" aria-label="Loading">
              <i class="pi pi-spin pi-spinner dashboard-shell-refresh-icon" aria-hidden="true"></i>
            </span>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Main content: each tab injects its own p-col-* children directly into this grid -->
  <ng-content></ng-content>
</div>
